import Vue from 'vue';
import PortalVue from 'portal-vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import '@/assets/tailwind.css';
import './plugins/element';
import './services';
import './plugins/global-components';
import './plugins/global-filter';

Vue.use(PortalVue);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
